import Vue from 'vue';
import VueRouter from 'vue-router';
import SignUp from './views/sign-up.vue';
import SignIn from './views/sign-in.vue';
import Home from './views/home.vue';
import Orders from './views/orders.vue';
import Shipments from './views/shipments.vue';
import Products from './views/products.vue';
import Details from './views/details.vue';
import Order from './views/order.vue';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/sign-up',
      component: SignUp,
    },
    {
      path: '/sign-in',
      component: SignIn,
    },
    {
      path: '/',
      component: Home,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          component: Orders,
        },
        {
          path: 'shipments',
          component: Shipments,
        },
        {
          path: 'products',
          component: Products,
        },
        {
          path: 'details',
          component: Details,
        },
        {
          path: ':orderID',
          component: Order,
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
